import { camelCase } from '@gitbook/util-format';

/**
 * Convert a document property name to the corresponding HAST data attribute name.
 *
 * HAST represents `data-foo-bar` as `dataFooBar` in element properties.
 */
export function toDataAttribute(property: string): string {
    return `data${camelCase(property, { pascalCase: true })}`;
}
